<div class="ticket-detail-card-details">
  <div class="label-value-wrapper">
    <span class="label">CATEGORY</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.boardName ?? '-' }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">DATE CREATED</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.dateEntered | hubDate }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">LAST UPDATED</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.lastUpdated | hubDate }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">CONTACT</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.contactFullName ?? '-' }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">TYPE</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.typeName ?? '-' }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">SUBTYPE</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.subTypeName ?? '-' }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">ITEM</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.itemName ?? '-' }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">CONTACT PHONE</span>
    @if (!isLoadingData) {
      <span class="value">
        @if (ticket?.contactFullPhone) {
          {{ ticket.contactFullPhone }}
        } @else {
          -
        }
      </span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">CONTACT EMAIL</span>
    @if (!isLoadingData) {
      @if (ticket?.contactEmail) {
        <a href="mailto:{{ ticket.contactEmail }}" class="value">
          {{ trimContactEmail(ticket.contactEmail) }}
        </a>
      } @else {
        <span>-</span>
      }
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper site">
    <span class="label">SITE</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.siteName ?? '-' }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  @if (isBusinessUnitEnabled) {
    <div class="label-value-wrapper">
      <span class="label">BUSINESS UNIT</span>
      @if (!isLoadingData) {
        <span class="value">{{ ticket?.businessUnitName ?? '-' }}</span>
      } @else {
        <ngx-skeleton-loader
          [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
        ></ngx-skeleton-loader>
      }
    </div>
  }

  <div class="label-value-wrapper">
    <span class="label">ASSIGNED TO</span>
    @if (!isLoadingData) {
      <span class="value">
        @if (ticket?.ownerFullName) {
          {{ ticket.ownerFullName }}
        } @else {
          -
        }
      </span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">SERVICE TEAM</span>
    @if (!isLoadingData) {
      <span class="value">{{ ticket?.teamName ?? '-' }}</span>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="label-value-wrapper">
    <span class="label">RESOURCES</span>

    @if (!isLoadingData) {
      <div class="resources udt-blue-scrollbar">
        @if ((ticket?.resources?.length ?? 0) > 0) {
          @for (resource of ticket?.resources ?? []; track resource.email ?? resource.name) {
            <div>
              @if (resource.email) {
                <a
                  href="mailto:{{ resource.email }}"
                  [matTooltip]="resource.email"
                  matTooltipPosition="above"
                  class="value"
                >
                  {{ resource.name }}
                </a>
              } @else {
                <span class="no-email">{{ resource.name }}</span>
              }
            </div>
          }
        } @else {
          <div>-</div>
        }
      </div>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>

  <div class="customer-issue-description udt-blue-scrollbar">
    <div class="title">CUSTOMER ISSUE DESCRIPTION</div>

    @if (!isLoadingData) {
      <p>
        <markdown [data]="ticket?.customerIssueDescription"></markdown>
      </p>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ width: '75%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{ width: '60%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
      <br />
      <ngx-skeleton-loader
        [theme]="{ width: '75%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{ width: '60%', height: '16px', background: 'var(--background-input-v2)' }"
      ></ngx-skeleton-loader>
    }
  </div>
</div>
